const scheduledServicesUsersFilterModal = {
  "filter": "FILTROS",
  "clear": "Limpiar Filtros",
  "site": "Sites",
  "role": "Roles",
  "cancel": "CANCELAR",
  "ok": "APLICAR",
};

export default scheduledServicesUsersFilterModal;